module.exports = __webpack_public_path__ + "img/body_bg2.d033cc5a.png";